import { useEffect, useMemo, useRef, useState } from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useFilters,
  usePagination,
  useRowSelect,
} from "react-table";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import { ZAHTJEVI_COLUMNS } from "../../common/initialValues/initialValues";

import arrowDown from "../../assets/icons/arrow-down-orange-icon.svg";
import noResultImage from "../../assets/icons/no-results-illustration.svg";
import calendarIcon from "../../assets/icons/calendar-icon.svg";
import binIcon from "../../assets/icons/bin-icon.svg";
import confirmIcon from "../../assets/icons/confirm-icon.svg";
import retryIcon from "../../assets/icons/retry-icon.svg";
import closeIcon from "../../assets/icons/close-icon.svg";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import {
  pretvoriDatumuFormatTablice,
  pretvoriStatusZahtjevaUFormatTablice,
  searchRequestDate,
  searchRequestDateRange,
  zahtjevToZahtjevTable,
} from "../../common/utils/HelperFunction";
import { Checkbox } from "./Checkbox";

import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css"; //Obrisati nakon postavljanja stylea za kalendar

import {
  CalendarValue,
  DocumentsFilter,
  SearchDocument,
  Zahtjev,
  ZahtjevTable,
} from "../../common/types/types";
import { useNavigate } from "react-router-dom";
import ZahtjeviService from "../../service/ZahtjeviService";
import { ArchivedDocumentDetails } from "./ArchivedDocumentDetails";
import { Pagination } from "../reusableWidgets/Pagination";

import {
  setDohvaceniZahtjevi,
  toggleUpdateDocumentsTable,
} from "../../store/slice/ZahtjeviSlice";
import DeleteDocument from "./DeleteDocument";
import ActionBar from "../other/ActionBar";
import { setReachedDocumentsFilter } from "../../store/slice/DocumentsFilterSlice";

interface ZahtjeviTableProps {
  status: number;
  toastMessage: (message: string) => void;
}
export const ZahtjeviTable = ({ status, toastMessage }: ZahtjeviTableProps) => {
  const [zahtjevi, setZahtjevi] = useState<ZahtjevTable[]>([]);
  const [zahtjeviFiltered, setZahtjeviFiltered] = useState<ZahtjevTable[]>([]);
  const [zahtjeviZaPrikaz, setZahtjeviZaPrikaz] = useState<ZahtjevTable[]>([]);

  const updateTable = useAppSelector((state) => state.zahtjevi.updateTable);
  const documentsFilter = useAppSelector(
    (state) => state.documentsFiler.reachedDocumentsFilter
  );

  const columns = useMemo(() => ZAHTJEVI_COLUMNS, []);
  const data = useMemo(() => zahtjeviZaPrikaz, [zahtjeviZaPrikaz]);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [activeCalendar, setActiveCalendar] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<boolean>(() =>
    documentsFilter.date && Array.isArray(documentsFilter.date) ? true : false
  );
  const [calendarValue, setCalendarValue] = useState<CalendarValue | undefined>(
    documentsFilter.date
  );
  const [searchLabel, setSearchLabel] = useState<string | undefined>(() =>
    Array.isArray(documentsFilter.date)
      ? searchRequestDateRange(documentsFilter.date as Array<Date>, false)
      : searchRequestDate(documentsFilter.date as Date, false)
  );
  const [modalArchivedOn, setModalArchivedOn] = useState<boolean>(false);
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [documentToDeleteId, setDocumentToDeleteId] = useState<Array<string>>(
    []
  );
  // const [modalOn, setModalOn] = useState<boolean>(true);

  const [filterValue, setFilterValue] = useState<string>(
    documentsFilter.search
  );

  const [archivedDocument, setArchivedDocument] = useState<
    ZahtjevTable | undefined
  >();

  let calendarRef = useRef<HTMLDivElement>(null);

  const getDocuments = () => {
    let requestDate = undefined;
    let requestDateRange = undefined;
    calendarValue &&
      (!endDate
        ? (requestDate = searchRequestDate(calendarValue as Date, true))
        : (requestDateRange = searchRequestDateRange(
            calendarValue as Array<Date>,
            true
          )));

    let filterTerm = null;
    if (filterValue.length >= 3) filterTerm = filterValue;

    const searchRequest: SearchDocument = {
      date: requestDate,
      date_range: requestDateRange,
      search_term: filterTerm,
    };
    calendarValue || (filterValue && filterValue.length >= 3)
      ? // Ukoliko ima unesenih filtera, salje se request searchDocument
        ZahtjeviService.searchDocuments(searchRequest)
          .then((response) => {
            setZahtjeviFiltered(response.data);
          })
          .catch((error) => {
            setZahtjeviFiltered([]);
            console.log(error);
          })
      : // Ukoliko nema unsenih filtera, salje se request getZahtjevi
        ZahtjeviService.getZahtjevi()
          .then((response) => {
            // setZahtjevi(response.data);

            ZahtjeviService.getArchivedZahtjevi().then((responseArchived) => {
              setZahtjevi([...response.data, ...responseArchived.data]);
              dispatch(
                setDohvaceniZahtjevi(
                  zahtjevToZahtjevTable([
                    ...response.data,
                    ...responseArchived.data,
                  ])
                )
              );
            });
          })
          .catch((error) => {
            console.log("Error fetching documents: ", error);
            setZahtjevi([]);
            console.log(error);
          });
  };

  const calendarChange = (event: CalendarValue | undefined) => {
    setCalendarValue(event);
    endDate
      ? setSearchLabel(searchRequestDateRange(event as Array<Date>, false))
      : setSearchLabel(searchRequestDate(event as Date, false));

    dispatch(
      setReachedDocumentsFilter({
        tabStatus: documentsFilter.tabStatus,
        tabText: documentsFilter.tabText,
        date: event,
        search: filterValue,
      } as DocumentsFilter)
    );

    // let filterTerm = null;
    // if (filterValue.length >= 3) filterTerm = filterValue;
    // getDocuments(filterTerm, event);
  };

  const searchChange = (event: string) => {
    setFilterValue(event);
    if (event.length >= 3 || event.length === 0) {
      // getDocuments(event, calendarValue);
    }
    dispatch(
      setReachedDocumentsFilter({
        tabStatus: documentsFilter.tabStatus,
        tabText: documentsFilter.tabText,
        date: calendarValue,
        search: event,
      } as DocumentsFilter)
    );
  };

  useEffect(() => {
    getDocuments();
  }, [calendarValue, filterValue, updateTable]);

  useEffect(() => {
    let onMouseDown = (e: any) => {
      if (!calendarRef.current?.contains(e.target)) {
        setActiveCalendar(false);
      }
    };

    document.addEventListener("mousedown", onMouseDown);

    return () => {
      document.removeEventListener("mousedown", onMouseDown);
    };
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    prepareRow,
    canNextPage,
    canPreviousPage,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    rows,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      // initialState: { pageIndex: 0 },
      initialState: {
        pageSize: 100,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
              <Checkbox {...row.getToggleRowSelectedProps()} />
            ),
          },
          ...columns,
        ];
      });
    }
  );

  const { pageIndex, pageSize } = state;

  useEffect(() => {
    let zahtjeviZaPripremu;
    if (filterValue.length >= 3 || calendarValue) {
      //get search
      zahtjeviZaPripremu = zahtjeviFiltered;
    } else {
      //get zahtjevi
      zahtjeviZaPripremu = zahtjevi;
    }

    if (status === 3 || status === 7)
      setZahtjeviZaPrikaz(
        zahtjeviZaPripremu.filter(
          (zahtjev) => zahtjev.Status === 3 || zahtjev.Status === 7
        )
      );
    else if (status === 0)
      setZahtjeviZaPrikaz(
        zahtjeviZaPripremu.filter((zahtjev) => zahtjev.Status !== 5)
      );
    else
      setZahtjeviZaPrikaz(
        zahtjeviZaPripremu.filter((zahtjev) => zahtjev.Status === status)
      );
    // setModalOn(false);
  }, [status, zahtjevi, zahtjeviFiltered]);

  const handleDocumentClick = (
    id: string | number,
    name: string | null,
    status: number | null,
    editable: boolean
  ) => {
    if (status === 5) {
      if (filterValue.length < 3 && !calendarValue) {
        console.log("Zahtjevi: ", zahtjevi);
        var archivedDoc = zahtjevi.filter((zahtjev) => zahtjev.ID === id);
        setArchivedDocument(archivedDoc[0]);
      } else {
        console.log("Zahtjevi filtered: ", zahtjeviFiltered);
        var archivedDoc = zahtjeviFiltered.filter(
          (zahtjev) => zahtjev.ID === id
        );
        setArchivedDocument(archivedDoc[0]);
      }
      // var archivedDoc = zahtjevi.filter((zahtjev) => zahtjev.ID === id);

      setModalArchivedOn(true);
    } else {
      navigate("manageDocument", {
        state: { documentId: id, documentName: name, editableData: editable },
      });
      // setModalDelete(true); // Merged 29. July Cvitko: Added multidelete; actionBar; typography small update; added delete modal; manage document - Company autofill by AltVAT
    }
  };

  const removeDateFilter = () => {
    setCalendarValue(undefined);
    setSearchLabel("");
    calendarChange(undefined);
  };

  const confirmDocument = (zahtjev: Zahtjev) => {
    ZahtjeviService.confirmDocument(zahtjev).then((response) => {
      dispatch(toggleUpdateDocumentsTable());
      toastMessage("Document confirmed");
    });
  };

  const deleteDocument = (id: string) => {
    setDocumentToDeleteId([id as string]);
    setModalDelete(true);
  };

  const deleteMultipleDocuments = () => {
    const selectedIds: Array<string> = [];
    selectedFlatRows.forEach((item) => {
      selectedIds.push(item.original.ID as string);
    });
    setDocumentToDeleteId(selectedIds);
    setModalDelete(true);
    console.log(selectedIds);
  };

  return (
    <div className="relative font-h5-regular margin-bottom-6">
      {modalArchivedOn && (
        <ArchivedDocumentDetails
          details={archivedDocument}
          setModalArchivedOn={setModalArchivedOn}
        ></ArchivedDocumentDetails>
      )}
      {modalDelete && (
        <DeleteDocument
          documentIds={documentToDeleteId}
          deleteSource={1}
          setModalDelete={setModalDelete}
          toastMessage={toastMessage}
        />
      )}
      {selectedFlatRows.length > 0 &&
        (status === 1 || status === 2 || status === 4) && (
          <ActionBar
            selectedItemsCount={selectedFlatRows.length}
            handleDelete={deleteMultipleDocuments}
          />
        )}
      <div className="filters ">
        {searchLabel && (
          <>
            <span className="filters__selected-filter font-h6-regular">
              {searchLabel}
            </span>
            <img
              className="filters__close-icon"
              onClick={removeDateFilter}
              src={closeIcon}
              alt="X"
            />
          </>
        )}
        <div className="filters__date" ref={calendarRef}>
          <img
            className="filters__date__icon"
            onClick={() => setActiveCalendar((prevState) => !prevState)}
            src={calendarIcon}
            alt="Calendar"
          />
          <div
            className={`${
              activeCalendar ? "" : "hide"
            } filters__date__calendar`}
          >
            <Calendar
              selectRange={endDate}
              onChange={(event) => {
                calendarChange(event);
              }}
              value={calendarValue}
            />
            <div className="form-check form-switch text-left">
              <input
                title="end date"
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={endDate}
                onClick={() => setEndDate(!endDate)}
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckChecked"
              >
                end date
              </label>
            </div>
          </div>
        </div>
        <div className="global-filter">
          <input
            className="form__item__input font-h5-regular"
            type="text"
            placeholder="Search"
            value={documentsFilter.search}
            onChange={(event) => searchChange(event.target.value)}
          />
        </div>
      </div>
      {page.length ? (
        <>
          <table className="font-h5-regular simply-table" {...getTableProps}>
            <thead className="simply-table__head">
              {headerGroups.map((headerGroup, index) => (
                <tr
                  className="simply-table__head__row"
                  {...headerGroup.getFooterGroupProps()}
                  key={index}
                >
                  {headerGroup.headers.map((column, i) => {
                    if (column.id === "selection") {
                      if (status !== 1 && status !== 2 && status !== 4) {
                        return (
                          <th
                            className={`${
                              column.isSorted ? "primary-200" : ""
                            } simply-table__head__row__th font-h5-regular checkbox`}
                            key={i}
                          ></th>
                        );
                      }
                    }
                    const columnName = String(column.Header)
                      .toLocaleLowerCase()
                      .replace(" ", "");
                    return (
                      <th
                        className={`${
                          column.isSorted ? "primary-200" : ""
                        } simply-table__head__row__th font-h5-regular ${
                          column.id === "selection" ? "checkbox" : columnName
                        }`}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <span>{column.render("Header")}</span>

                        {column.isSorted ? (
                          <img
                            src={arrowDown}
                            alt=""
                            className={`${column.isSortedDesc && "rotate-180"}`}
                          />
                        ) : (
                          ""
                        )}
                      </th>
                    );
                  })}
                  <th className="simply-table__head__row__th font-h5-regular action-icons"></th>
                </tr>
              ))}
            </thead>
            <tbody className="simply-table__body" {...getTableBodyProps}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <tr
                    className="simply-table__body__row"
                    {...row.getRowProps()}
                    key={index}
                  >
                    {row.cells.map((cell, i) => {
                      if (cell.column.id === "selection") {
                        if (status !== 1 && status !== 2 && status !== 4) {
                          return (
                            <td
                              className="simply-table__body__column"
                              key={i}
                            ></td>
                          );
                        }
                      }
                      if (cell.column.Header == "Status") {
                        return (
                          <td
                            className="simply-table__body__column"
                            {...cell.getCellProps()}
                            key={i}
                          >
                            <span
                              className={`font-h6-bold simply-table__body__column__status-${cell.value}`}
                            >
                              {cell.value === 0
                                ? "In Queue"
                                : pretvoriStatusZahtjevaUFormatTablice(
                                    cell.value,
                                    `Invalid status: ${cell.value}`
                                  )}
                            </span>
                          </td>
                        );
                      } else if (cell.column.Header == "Name") {
                        if (
                          row.original.Status !== 2 &&
                          row.original.Status !== 3 &&
                          row.original.Status !== 4 &&
                          row.original.Status !== 5 &&
                          row.original.Status !== 7
                        ) {
                          return (
                            <td
                              className="simply-table__body__column"
                              {...cell.getCellProps()}
                              key={i}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        } else {
                          let editableData = true;
                          if (
                            row.original.Status === 3 ||
                            row.original.Status === 7
                          )
                            editableData = false;
                          return (
                            <td
                              className="simply-table__body__column pointer"
                              {...cell.getCellProps()}
                              onClick={() =>
                                handleDocumentClick(
                                  row.original.ID,
                                  row.original.Name,
                                  row.original.Status,
                                  editableData
                                )
                              }
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        }
                      } else if (cell.column.Header == "Uploaded At") {
                        return (
                          <td
                            className="simply-table__body__column"
                            {...cell.getCellProps()}
                          >
                            {pretvoriDatumuFormatTablice(
                              cell.value,
                              `Invalid date: ${cell.value}`
                            )}
                          </td>
                        );
                      } else if (cell.column.Header == "Size") {
                        return (
                          <td
                            className="simply-table__body__column"
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")} Mb
                          </td>
                        );
                      } else
                        return (
                          <td
                            className="simply-table__body__column"
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                    })}
                    <td className="simply-table__body__column text-right">
                      {row.original.Status === 4 && (
                        <>
                          <Tippy content="Confirm">
                            <img
                              className="pointer"
                              src={confirmIcon}
                              alt="confirm"
                              onClick={() => confirmDocument(row.original)}
                            />
                          </Tippy>
                          <Tippy content="Retry">
                            <img
                              className="pointer"
                              src={retryIcon}
                              alt="retry"
                              onClick={() =>
                                handleDocumentClick(
                                  row.original.ID,
                                  row.original.Name,
                                  row.original.Status,
                                  true
                                )
                              }
                            />
                          </Tippy>
                        </>
                      )}
                      {(row.original.Status === 1 ||
                        row.original.Status === 2 ||
                        row.original.Status === 4) && (
                        <Tippy content="Delete">
                          <img
                            src={binIcon}
                            className="pointer"
                            onClick={() =>
                              deleteDocument(row.original.ID as string)
                            }
                            alt="del"
                          />
                        </Tippy>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <Pagination
            rowsLength={rows.length}
            pageCount={pageCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            gotoPage={gotoPage}
            previousPage={previousPage}
            nextPage={nextPage}
            setPageSize={setPageSize}
          />

          {/*
          -------------------------------------------------------------------------------------------------------------------------------------------
          Comment for deploy
          -------------------------------------------------------------------------------------------------------------------------------------------
          <pre>
            <code>
              {JSON.stringify(
                {
                  selectedFlatRows: selectedFlatRows.map((row) => row.original),
                },
                null,
                2
              )}
            </code>
          </pre>
          */}
        </>
      ) : (
        <div className="text-center padding-top-4">
          <picture className="height-60">
            <img className="height-60" src={noResultImage} alt="" />
          </picture>
          <h3 className="font-h3-regular">No result</h3>
          <p className="h6-regular dark-400">
            Please check the spelling or try different keywords
          </p>
        </div>
      )}
    </div>
  );
};
